module.exports = __webpack_public_path__ + "img/banner-dog-tab.2a8e39b7.jpg";